import React from 'react';

export function Eye({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}>
      <path
        d="M8 3C4.36364 3 1.25818 5.28067 0 8.5C1.25818 11.7193 4.36364 14 8 14C11.6364 14 14.7418 11.7193 16 8.5C14.7418 5.28067 11.6364 3 8 3ZM8 12.1667C5.98545 12.1667 4.36364 10.524 4.36364 8.5C4.36364 6.476 5.98545 4.83333 8 4.83333C10.0145 4.83333 11.6364 6.476 11.6364 8.5C11.6364 10.524 10.0145 12.1667 8 12.1667ZM8 6.3C6.79636 6.3 5.81818 7.28533 5.81818 8.5C5.81818 9.71467 6.79636 10.7 8 10.7C9.20364 10.7 10.1818 9.71467 10.1818 8.5C10.1818 7.28533 9.20364 6.3 8 6.3Z"
        fill="currentColor"
      />
    </svg>
  );
}
